// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import $ from 'jquery'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import '@/assets/css/sweetalert.css'
import '@/assets/css/main.css'
import '@/assets/css/index.scss'
import request from "@/utils/request";
window.request = request;

// 全局组件
import header from '@/components/Header' // 全局头
import footer from '@/components/Footer' // 全局尾
Vue.component('YXHeader', header)
Vue.component('YXFooter', footer)
Vue.config.productionTip = false
window.$ = $;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  mounted () {
    // You'll need this for renderAfterDocumentEvent.
    document.dispatchEvent(new Event('render-active'))
  }
})



// WEBPACK FOOTER //
// ./src/main.js